import data from "@/public/data/flight/flight.json";
import {
  RadioGroup,
  RadioGroupItem,
} from "@/shared/components/common/RadioButton";
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/shared/components/common/form";

import config from "@/configs/config";
import Flex from "@/shared/components/common/Flex";

import type { Control, FieldValues } from "react-hook-form";
import type { FlightSchemaType } from "@/shared/schemas/flight/flightTab.Schema";
import Typography from "@/shared/components/common/Typography";

type FlightType = "one-way" | "round-trip";
interface FlightTypeProps {
  control: Control<FieldValues & FlightSchemaType>;
  selected: FlightType;
}

export default function FlightType({ control, selected }: FlightTypeProps) {
  const {
    mainForm: { radioButtons },
  } = data;

  return (
    <Flex className="p-2 max-md:justify-between rounded-xs gap-x-3">
      <FormField
        control={control}
        name="flightType"
        render={({ field }) => (
          <FormItem className="gap-y-3 w-full">
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                defaultValue={field.value}
                className="px-6 w-full"
                dir={config.dir}
              >
                <Flex className="gap-x-2">
                  {radioButtons.map(({ title, value }) => (
                    <FormItem key={value} className="max-md:basis-1/2">
                      <Flex
                        onClick={() => field.onChange(value)}
                        className={`flex items-start justify-center cursor-pointer rounded-xs px-4 h-full py-3 bg-primary text-background dark:text-foreground ${
                          selected === value ? "" : " opacity-50"
                        } sm:justify-start shadow-1 hover:shadow-2 transition duration-100 ease-ease-in-out-circ `}
                      >
                        <FormControl>
                          <RadioGroupItem
                            value={value}
                            hidden
                            className="cursor-pointer"
                          />
                        </FormControl>
                        <Typography className="font-normal text-sm cursor-pointer">
                          {title}
                        </Typography>
                      </Flex>
                    </FormItem>
                  ))}
                </Flex>
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </Flex>
  );
}
